'use client';

import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation, Pagination} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {FiArrowLeft, FiArrowRight} from "react-icons/fi";
import NewsCard from "@/components/news-card/news-card"

const NewsCardSlider = ({id, setActiveColor, slides, centeredSlides}: {
    id: string,
    setActiveColor?: any,
    slides: any[],
    centeredSlides: boolean
    }) => {
        return (
            <div id={id} className={"common-slider"}>
                <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={32}
                    slidesPerView="auto"
                    navigation={{
                        nextEl: `#${id} .custom-next`,
                        prevEl: `#${id} .custom-prev`,
                    }}
                    pagination={{
                        clickable: true,
                        el: `#${id} .custom-pagination`,
                    }}
                    centeredSlides={centeredSlides}
                    loop={true}
                    className="w-full"
                    onSlideChange={(swiper) => setActiveColor && setActiveColor(
                        slides[swiper.realIndex]?.content?._class === "series" || slides[swiper.realIndex]?.content?._class === "movie" ? "#FE22EA" :
                        slides[swiper.realIndex]?.content?._class === "game" ? "#A9F958" : "#2CC2F9"
                    )}
                >
                    {slides.map((slide) => (
                        <SwiperSlide key={slide.id}>
                            <NewsCard news={slide}/>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="mt-6 flex justify-center">
                    <div
                        className="custom-controls flex items-center gap-4 px-4 py-1 rounded-lg"
                        style={{minWidth: '200px', justifyContent: 'center'}}
                    >
                        <button className="custom-prev text-white text-2xl">
                            <FiArrowRight/>
                        </button>

                        <div className="custom-pagination flex"></div>
                        <button className="custom-next text-white text-2xl">
                            <FiArrowLeft/>
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    export default NewsCardSlider;
